import { server_endpoint } from "../store";
import axios from "axios";

export const getCoursesAction = (category="", keyword="") => async (dispatch) => {
    try {
      dispatch({
        type: "allCoursesRequest",
      });
    //   const userdata = {
    //     category,
    //     keyword,
    //   };

    //   console.log(userdata)
  
      const data = await axios.get(`${server_endpoint}/courses`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
  
    //   console.log(data);
      dispatch({
        type: "allCoursesSuccess",
        payload: data.data.courses,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: "allCoursesFail",
        payload: error?.response?.data?.message,
      });
    }
  };


 
export const getCourseLecturesAction = (_id) => async (dispatch) => {
  try {
    dispatch({
      type: "getLecturesRequest",
    });
    // const userdata = {
    //   _id
    // };

    // console.log(userdata)

    const data = await axios.get(`${server_endpoint}/course/${_id}`,  {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });

    // console.log(data);
    dispatch({
      type: "getLecturesSuccess",
      payload: data.data.lectures,
    });
  } catch (error) {
    // console.log(error);
    dispatch({
      type: "getLecturesFail",
      payload: error?.response?.data?.message,
    });
  }
};

